import { IPath } from "Router/index";
import { NavigationFailure, Router } from "vue-router";

type INavigationParameter = {
    [key: string]: any
}

export interface INavigationService {
    navigateTo(routeObject: IPath, params?: INavigationParameter, query?: INavigationParameter): Promise<void | NavigationFailure | undefined>;
    navigate(path: string, params?: INavigationParameter): Promise<void | NavigationFailure | undefined>;
    replace(routeObject: IPath, params?: INavigationParameter): Promise<void | NavigationFailure | undefined>;
    navigateToDetail(routeObject: IPath, id: string): Promise<void | NavigationFailure | undefined>;
    goBack(numberPage?: number): void;
}

export class NavigationService implements INavigationService {
    constructor(private router: Router) { }
    navigateTo(routeObject: IPath, params?: INavigationParameter, query?: INavigationParameter): Promise<void | NavigationFailure | undefined> {
        if (!!params) {
            return this.router.push({ name: routeObject.name, params: params, query: query });
        }
        else {
            return this.router.push({ name: routeObject.name });
        }
    }
    navigate(path: string, params?: INavigationParameter): Promise<void | NavigationFailure | undefined> {
        if (!!params) {
            return this.router.push({ name: path, params: params });
        }
        else {
            return this.router.push({ name: path });
        }
    }
    replace(routeObject: IPath, params?: INavigationParameter): Promise<void | NavigationFailure | undefined> {
        if (!!params) {
            return this.router.replace({ name: routeObject.name, params: params });
        }
        else {
            return this.router.replace({ name: routeObject.name });
        }
    }
    navigateToDetail(routeObject: IPath, id: string): Promise<void | NavigationFailure | undefined> {
        return this.router.push({ name: routeObject.name, params: { id: id } });
    }
    goBack(numberPage?: number): void {
        this.router.go(numberPage ?? -1);
    }
}